import React, { useState, useEffect } from "react";
import { css } from "emotion";
import InputForm from "../InputForm";
import creditCardUtils from "./creditCardUtils";
import { isEmpty } from "ramda";

import { imgBrandStyle } from "./style";
import { defaultCreditCardMask } from "../../create-offer/utils/masks";

const InputCreditCard = ({ innerRef, getActiveBrand, ...rest }) => {
	const [activeBrand, setActiveBrand] = useState(undefined);
	const [mask, setMask] = useState(defaultCreditCardMask);

	useEffect(() => {
		getActiveBrand(activeBrand);
	}, [activeBrand]);

	const handleTyped = (brandTyped = "") => {
		brandTyped = String(brandTyped).replace(/[^0-9.]/g, "");
		const { onBrandChanged } = rest;

		if (isEmpty(brandTyped)) {
			setActiveBrand(undefined);
			return undefined;
		}

		const [brand, brandDetails] = creditCardUtils.getBrand(brandTyped);

		if (brand !== activeBrand) {
			setActiveBrand(brand);

			if (brandDetails && brandDetails.gaps && brandDetails.gaps.length) {
				let maxLength = Math.max(...brandDetails.lengths);
				let mask = [];
				for (let i = 0; i < maxLength; i++) {
					if (brandDetails.gaps.includes(i)) {
						mask.push(" ");
					}
					mask.push(/\d/);
				}
				setMask(mask);
			}

			if (onBrandChanged) {
				onBrandChanged(brandDetails);
			}
		}

		return brandDetails;
	};

	const handleOnChange = e => {
		const { onChange } = rest;
		onChange(e, handleTyped(e.target.value));
	};

	const imgBrand = activeBrand ? (
		<img
			key={activeBrand}
			alt={`Cartão ${activeBrand}`}
			className={css`
				${imgBrandStyle}
			`}
			src={`https://s3.amazonaws.com/maxmilhas/etc/imagens/cards/${activeBrand}.svg`}
		/>
	) : null;

	return (
		<InputForm
			{...rest}
			type="tel"
			mask={mask}
			guide={true}
			placeholderChar={"\u2000"}
			ref={innerRef}
			onChange={handleOnChange}
			icon={imgBrand}
		/>
	);
};

export default InputCreditCard;
